export enum StatusTagColor {
    Green,
    Yellow,
    Red,
    Gray,
}

export enum TagSize {
    Small,
    Medium,
    Large,
}

export function StatusTag({ statusText, statusTagColor, tagSize = TagSize.Small }: { statusText: string, statusTagColor: StatusTagColor, tagSize?: TagSize }) {
    var bordercolor = "border-slate-700";
    var textcolor = "text-slate-500";
    var colorBackground = "bg-slate-500";
    var statusTagSize = "text-xs min-w-18 max-h-6"
    
    switch (statusTagColor) {
        case StatusTagColor.Green:
            bordercolor = "border-green-500";
            colorBackground = "bg-green-300";
            break;
        case StatusTagColor.Yellow:
            bordercolor = "border-yellow-500";
            colorBackground = "bg-yellow-300";
            break;
        case StatusTagColor.Red:
            bordercolor = "border-rose-500";
            colorBackground = "bg-rose-300";
            break;
        case StatusTagColor.Gray:
            bordercolor = "border-slate-500";
            colorBackground = "bg-slate-300";
            break;
    }

    switch (tagSize) {
        case TagSize.Small:
            statusTagSize = "text-xs min-w-24 max-h-8";
            break;
        case TagSize.Medium:
            statusTagSize = "text-lg min-w-32 max-h-10";
            break;
        case TagSize.Large:
            statusTagSize = "text-lg";
    }
    
    return (
        <div className={"rounded-md py-2 px-2 border text-center ml-2 " + statusTagSize + " " + colorBackground + " " + bordercolor + " " + textcolor} >
            {statusText}
        </div>
    );
}
